module.exports = __webpack_public_path__ + "minus-icon-4a5f7aebe596fca2cd22cad73eb200f3.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/icons/minus-icon.svg
// module id = 53
// module chunks = 0